export const DATA_TEXTURE_SIZE = 256;
